import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    padding: '90px 35px',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '130px',
    [theme.breakpoints.up('md')]: {
      padding: '50px 100px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '50px 150px',
    },
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '55px',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      columnGap: '100px',
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: '200px',
    },
  },

  imgContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    position: 'relative',
    height: '250px',
    width: '250px',
    [theme.breakpoints.up('md')]: {
      height: '300px',
      width: '300px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '400px',
      width: '400px',
    },
  },

  titleDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      maxWidth: '600px',
    },
    [theme.breakpoints.up('lg')]: {
      rowGap: '20px',
    },
  },

  title: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },

  description: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
});
